<template>
  <div class="tabs btabs-compat">
    <div v-if="card" class="card-header">
      <ul role="tablist" class="nav nav-pills card-header-pills">
        <li
          v-for="(tab, index) in navTabs"
          :key="tab.uid"
          role="presentation"
          class="nav-item"
        >
          <a
            href="#"
            role="tab"
            class="nav-link"
            :class="{ active: activeIndex === index }"
            :aria-selected="activeIndex === index"
            @click.prevent="setActive(index)"
          >
            <template v-if="tab.titleRender().length">
              <template v-for="(node, nodeIndex) in tab.titleRender()" :key="nodeIndex">
                <component :is="node" />
              </template>
            </template>
            <span v-else>{{ tab.title }}</span>
          </a>
        </li>
      </ul>
    </div>
    <ul v-else role="tablist" :class="navClass">
      <li
        v-for="(tab, index) in navTabs"
        :key="'nav-' + tab.uid"
        role="presentation"
        class="nav-item"
      >
        <a
          href="#"
          role="tab"
          class="nav-link"
          :class="{ active: activeIndex === index }"
          :aria-selected="activeIndex === index"
          @click.prevent="setActive(index)"
        >
          <template v-if="tab.titleRender().length">
            <template v-for="(node, nodeIndex) in tab.titleRender()" :key="nodeIndex">
              <component :is="node" />
            </template>
          </template>
          <span v-else>{{ tab.title }}</span>
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BTabs',
  props: {
    pills: { type: Boolean, default: false },
    card: { type: Boolean, default: false }
  },
  data () {
    return {
      navTabs: [],
      activeIndex: 0
    }
  },
  computed: {
    navClass () {
      return [
        'nav',
        this.pills ? 'nav-pills' : 'nav-tabs'
      ]
    }
  },
  provide () {
    return { btabs: this }
  },
  methods: {
    setActive (index) {
      this.activeIndex = index
    },
    registerTab (meta) {
      const uid = Symbol('btab')
      const index = this.navTabs.length
      this.navTabs.push({
        uid,
        title: meta.title || '',
        titleRender: meta.titleRender,
        active: !!meta.active
      })
      if (meta.active) {
        this.activeIndex = index
      }
      return { uid, index }
    },
    unregisterTab (uid) {
      const index = this.navTabs.findIndex((tab) => tab.uid === uid)
      if (index === -1) return
      this.navTabs.splice(index, 1)
      if (this.activeIndex >= this.navTabs.length) {
        this.activeIndex = Math.max(0, this.navTabs.length - 1)
      }
    }
  }
}
</script>
